var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 156,
    viewBox: "0 0 154 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77 153C119.415 153 153.799 118.75 153.799 76.5C153.799 34.2502 119.415 0 77 0C34.585 0 0.200806 34.2502 0.200806 76.5C0.200806 118.75 34.585 153 77 153Z",
    fill: "url(#paint0_linear_852_18654)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_852_18654)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_852_18654",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 154,
    height: 153
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9999 153C119.415 153 153.799 118.75 153.799 76.5C153.799 34.2502 119.415 0 76.9999 0C34.5849 0 0.200745 34.2502 0.200745 76.5C0.200745 118.75 34.5849 153 76.9999 153Z",
    fill: "url(#paint1_linear_852_18654)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_852_18654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.032 43.8594H32.9688C30.1411 43.8594 27.8488 46.1427 27.8488 48.9594V156.059C27.8488 158.876 30.1411 161.159 32.9688 161.159H121.032C123.859 161.159 126.152 158.876 126.152 156.059V48.9594C126.152 46.1427 123.859 43.8594 121.032 43.8594Z",
    fill: "white"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7838 54.0605H41.16C39.4634 54.0605 38.0881 55.4306 38.0881 57.1205C38.0881 58.8105 39.4634 60.1805 41.16 60.1805H67.7838C69.4804 60.1805 70.8557 58.8105 70.8557 57.1205C70.8557 55.4306 69.4804 54.0605 67.7838 54.0605Z",
    fill: "#EFEFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7838 96.9004H41.16C39.4634 96.9004 38.0881 98.2704 38.0881 99.9604C38.0881 101.65 39.4634 103.02 41.16 103.02H67.7838C69.4804 103.02 70.8557 101.65 70.8557 99.9604C70.8557 98.2704 69.4804 96.9004 67.7838 96.9004Z",
    fill: "#EFEFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.792 69.3594H43.2089C40.9468 69.3594 39.113 71.1861 39.113 73.4394V83.6394C39.113 85.8927 40.9468 87.7194 43.2089 87.7194H110.792C113.054 87.7194 114.888 85.8927 114.888 83.6394V73.4394C114.888 71.1861 113.054 69.3594 110.792 69.3594Z",
    stroke: "#4F46E5",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.791 111.18H43.208C40.3804 111.18 38.0881 113.463 38.0881 116.28V124.44C38.0881 127.256 40.3804 129.54 43.208 129.54H110.791C113.619 129.54 115.911 127.256 115.911 124.44V116.28C115.911 113.463 113.619 111.18 110.791 111.18Z",
    fill: "#EFEFFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4728 32.6405C56.735 32.6405 58.5688 30.8138 58.5688 28.5605C58.5688 26.3071 56.735 24.4805 54.4728 24.4805C52.2107 24.4805 50.3769 26.3071 50.3769 28.5605C50.3769 30.8138 52.2107 32.6405 54.4728 32.6405Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9996 32.6405C79.2618 32.6405 81.0956 30.8138 81.0956 28.5605C81.0956 26.3071 79.2618 24.4805 76.9996 24.4805C74.7375 24.4805 72.9037 26.3071 72.9037 28.5605C72.9037 30.8138 74.7375 32.6405 76.9996 32.6405Z",
    fill: "#4F46E5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5288 32.6405C101.791 32.6405 103.625 30.8138 103.625 28.5605C103.625 26.3071 101.791 24.4805 99.5288 24.4805C97.2666 24.4805 95.4328 26.3071 95.4328 28.5605C95.4328 30.8138 97.2666 32.6405 99.5288 32.6405Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2626 89.7605C91.0903 89.7605 93.3825 87.4772 93.3825 84.6605C93.3825 81.8439 91.0903 79.5605 88.2626 79.5605C85.4349 79.5605 83.1426 81.8439 83.1426 84.6605C83.1426 87.4772 85.4349 89.7605 88.2626 89.7605Z",
    fill: "#EFEFFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2644 106.458C91.4452 106.458 90.6803 106.458 89.984 106.414C89.1263 106.356 88.3012 106.064 87.5995 105.569C86.8979 105.075 86.3467 104.397 86.0068 103.61L81.6866 95.1054C81.3698 94.7379 81.2115 94.2606 81.2465 93.7774C81.2814 93.2942 81.5066 92.8444 81.873 92.5258C82.1732 92.2855 82.5477 92.1561 82.9328 92.1597C83.2164 92.1679 83.4947 92.2372 83.7488 92.363C84.0028 92.4887 84.2265 92.6678 84.4043 92.8879L86.3663 95.5552L86.3959 95.5899V85.4562C86.3959 84.9535 86.5965 84.4713 86.9533 84.1158C87.3102 83.7603 87.7943 83.5605 88.299 83.5605C88.8038 83.5605 89.2878 83.7603 89.6447 84.1158C90.0016 84.4713 90.2021 84.9535 90.2021 85.4562V92.0862C90.18 91.8423 90.2092 91.5964 90.2877 91.3642C90.3663 91.1321 90.4926 90.9188 90.6585 90.738C90.8243 90.5572 91.0262 90.4128 91.2513 90.314C91.4763 90.2151 91.7195 90.1641 91.9654 90.1641C92.2113 90.1641 92.4546 90.2151 92.6796 90.314C92.9046 90.4128 93.1065 90.5572 93.2724 90.738C93.4383 90.9188 93.5645 91.1321 93.6431 91.3642C93.7217 91.5964 93.7508 91.8423 93.7287 92.0862V93.4683C93.7066 93.2243 93.7358 92.9785 93.8144 92.7463C93.8929 92.5142 94.0192 92.301 94.1851 92.1201C94.351 91.9393 94.5529 91.7949 94.7779 91.696C95.0029 91.5972 95.2461 91.5462 95.492 91.5462C95.738 91.5462 95.9812 91.5972 96.2062 91.696C96.4312 91.7949 96.6331 91.9393 96.799 92.1201C96.9649 92.301 97.0912 92.5142 97.1697 92.7463C97.2483 92.9785 97.2775 93.2243 97.2554 93.4683V94.5332C97.2333 94.2892 97.2624 94.0433 97.341 93.8112C97.4195 93.5791 97.5458 93.3658 97.7117 93.185C97.8776 93.0042 98.0795 92.8597 98.3045 92.7609C98.5295 92.6621 98.7727 92.6111 99.0187 92.6111C99.2646 92.6111 99.5078 92.6621 99.7328 92.7609C99.9579 92.8597 100.16 93.0042 100.326 93.185C100.492 93.3658 100.618 93.5791 100.696 93.8112C100.775 94.0433 100.804 94.2892 100.782 94.5332V100.997C100.747 102.985 99.845 106.337 96.6717 106.337C96.4413 106.347 94.4896 106.459 92.2685 106.459L92.2644 106.458Z",
    fill: "#4F46E5",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_852_18654",
    x: 21.8488,
    y: 34.8594,
    width: 110.303,
    height: 121.141,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_852_18654"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_852_18654",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_852_18654",
    x1: 77,
    y1: 0,
    x2: 77,
    y2: 153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BACCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_852_18654",
    x1: 76.9999,
    y1: 0,
    x2: 76.9999,
    y2: 153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyChart);
export default __webpack_public_path__ + "static/media/empty-chart.8b4113b532b50e7e198e29b748529e15.svg";
export { ForwardRef as ReactComponent };